module.exports = __webpack_public_path__ + "img/gateways_admin.5f3897f7.svg";